import React from 'react'
import { Icon } from '@scentregroup/ui'

import { Centre } from '../../../types/centre'
import { makeMailUrl } from '../../helpers'
import ExternalLink from '../external-link'
import style from './index.module.scss'

export const CentreDetails: React.FC<{
  centre: Pick<
    Centre,
    | 'title'
    | 'physicalAddress'
    | 'suburb'
    | 'state'
    | 'postcode'
    | 'telephoneNumber'
    | 'emailAddress'
    | 'contactLinks'
  >
  onFindACentre?: () => void
}> = ({ centre, onFindACentre }) => (
  <div className={style.centreDetails}>
    <div className={style.centreInfo}>
      <div className={style.centreRow}>
        <span className={style.centreName}>{centre.title}</span>
        {onFindACentre && (
          <button className={style.changeCentre} onClick={onFindACentre}>
            Change&nbsp;centre
          </button>
        )}
      </div>
      <div className={style.centreAddress}>
        {centre.physicalAddress} <br />
        {centre.suburb} {centre.state} {centre.postcode} <br />
        <ExternalLink url={`tel:${centre.telephoneNumber}`}>
          {centre.telephoneNumber}
        </ExternalLink>
      </div>
      <ExternalLink
        url={makeMailUrl(centre.emailAddress)}
        className={style.contactConcierge}
      >
        {`Contact ${centre.title} Concierge`}
      </ExternalLink>
    </div>
    <div className={style.contactLinks} data-test-id="contact-links">
      {centre.contactLinks.map(
        contact =>
          contact.url && (
            <ExternalLink
              url={contact.url}
              key={contact.type}
              aria-label={`Go to Westfield ${centre.title}'s ${contact.type}`}
            >
              <Icon
                type={contact.type}
                size="medium"
                className={style.socialLogo}
              />
            </ExternalLink>
          )
      )}
    </div>
  </div>
)
